import { Suspense } from "react";

import { lazily } from "react-lazily";

import { DetailsSkeleton } from "app/components/skeletons";
import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { GroupDetailsRoute } = lazily(() => import("./GroupDetailsRoot"));

/** The /settings/access-control/groups/:groupUuid index route: see GroupDetailsRoot. */
export const groupDetailsRoute: PreloadingRouteProps = {
  element: (
    <Suspense fallback={<DetailsSkeleton />}>
      <GroupDetailsRoute />
    </Suspense>
  ),
  loader: lazyRouteLoader({
    load: () =>
      import("./groupDetailsPreload").then((module) =>
        module.createGroupDetailsLoader(),
      ),
    warm: () => import("./GroupDetailsRoot"),
  }),
  // The details page keeps its own query up to date while it is mounted (see
  // useRoutePreloadedQuery), and has no search or tab params of its own, so the
  // loader only runs again when the URL names a different group.
  shouldRevalidate: ({ currentParams, nextParams }) =>
    currentParams.groupUuid !== nextParams.groupUuid,
};
